import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const isAuthPage = ['/login', '/cadastro'].includes(location.pathname);
  const isHomePage = location.pathname === '/';

  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Background */}
      {isHomePage ? (
        <div className="fixed inset-0 bg-primary-600" />
      ) : (
        <div className="fixed inset-0 bg-gradient-to-br from-primary-600 via-primary-500 to-primary-300" />
      )}

      {/* Content */}
      <div className="relative flex-1">
        <Header forceBackground={isAuthPage} />
        <main className={isAuthPage ? 'pt-16' : ''}>
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
}